import { render } from "./ProspectAppsDetails.vue?vue&type=template&id=0ba6bb88"
import script from "./ProspectAppsDetails.vue?vue&type=script&lang=js"
export * from "./ProspectAppsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__